/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-06-30 18:04:35
 * @Description: 检测数据推送管理服务
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const pgsjtsService = {

  // 报告推送信息获取
  getJcbgSjts: (params) => { return axios.get(`${iffApi}/xfpg/pgbg/sjts`, { params: params }); },

  // 报告导入
  importBg: (fd) => { return axios.post(`${iffApi}/xfpg/pgbg/import`, fd); },

  // 全国系统数据推送
  qgxtSjts: (id) => { return axios.post(`${iffApi}/xfpg/pgbg/${id}/sjts/qgxt`); },

  // 广东社会平台数据推送
  gdshptSjts: (xmId, bgId) => { return axios.post(`${iffApi}/xfpg/pgbg/upload/gdshpt/${xmId}/${bgId}`); },

  // 获取广东社会平台数据推送结果
  getGdshptResult: (bgId) => { return axios.get(`${iffApi}/xfpg/pgbg/query/gdshpt/${bgId}/result`); },

  // 联网单位平台数据推送
  lwdwptSjts: (id) => { return axios.post(`${iffApi}/xfpg/pgbg/${id}/sjts/lwdwpt`); }

};
